<template>
  <div class="indexPage">
    <div class="searchBox">
      <el-input
        v-model="searchForm.keywords"
        placeholder="请输入关键字"
        style="margin-right: 10px"
      />

      <el-select v-model="searchForm.exhCode">
        <el-option
          v-for="item in ys"
          :key="item.code"
          :label="item.name"
          :value="item.code"
        ></el-option>
      </el-select>
      <el-button
        type="primary"
        style="width: 120px; height: 32px"
        color="#005baa"
        @click="queryList"
        >查询</el-button
      >
    </div>
    <div class="ltsBox">
      <ul>
        <li
          :class="
            searchForm.producttype === item.name ? 'typeimg active' : 'typeimg'
          "
          v-for="item in catas"
          :key="item.name"
          @click="changeCata(item.name)"
        >
          <img :src="item.imgUrl" alt="" />
        </li>
      </ul>
    </div>
    <template v-if="proList.length > 0">
      <div class="listBox">
        <div
          v-for="(item, index) in proList"
          :key="index"
          class="listItem"
          @click="toDetail(item.id)"
        >
          <img :src="item.imgurl ? item.imgurl : defaultImg" alt="" />
          <div class="itemContent">
            <div class="companyName">{{ item.atrname }}</div>
            <div class="compantInfor">
              <el-icon :size="16"><Location /></el-icon>
              <span>展位号： {{ item.bthcode }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- layout="total, prev, pager, next, jumper" -->
      <div class="pageBox">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchForm.pageIndex"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="searchForm.pageSize"
          layout="total, prev, pager, next"
          :total="total"
        >
        </el-pagination>
      </div>
    </template>
    <div
      v-else
      style="padding: 30px; text-align: center; font-size: 30px; color: #999"
    >
      暂无数据
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted, nextTick, reactive } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import api from '../../api'
import defaultImg from '@/assets/default.png'
import lt1 from '@/assets/lts/1.png'
import lt2 from '@/assets/lts/2.png'
import lt3 from '@/assets/lts/3.png'
import lt4 from '@/assets/lts/4.png'
import lt5 from '@/assets/lts/5.png'
import lt6 from '@/assets/lts/6.png'
import lt7 from '@/assets/lts/7.png'
import lt8 from '@/assets/lts/8.png'
const store = useStore()
const route = useRoute()
const router = useRouter()
const ys = [
{ code: '4082148f1a7e', name: '2026年' },
  { code: '413131a5d4de', name: '2025年' },
  { code: 'sjjgrgjxjlt', name: '2024年' }
]
const catas = [
  { imgUrl: lt1, name: '车轮制品' },
  { imgUrl: lt2, name: '轮胎翻新设备及原料' },
  { imgUrl: lt3, name: '轮胎制品' },
  { imgUrl: lt4, name: '汽车配件' },
  { imgUrl: lt5, name: '汽车维修保养' },
  { imgUrl: lt6, name: '润滑油及其他' },
  { imgUrl: lt7, name: '橡胶轮胎机械设备' },
  { imgUrl: lt8, name: '橡胶原材料' }
]
const toDetail = (id) => {
  router.push({ path: '/detail', query: { id } })
}
const total = ref()
const projectCode = '7032edfb62'
const searchForm = ref({
  atrname: '',
  bthcode: '',
  producttype: '',
  pageSize: 12,
  pageIndex: 1,
  projectCode: projectCode,
  exhCode: '4082148f1a7e'
})
const proList = ref([])
const getPros = async () => {
  const res = await api.GetElectronicListApi(searchForm.value)
  if (res.code !== 200) return
  if (res.data) {
    proList.value = res.data.result
    total.value = res.data.totalCount
  }
}
const queryList = () => {
  searchForm.pageIndex = 1
  getPros()
}
const handleSizeChange = (val) => {
  searchForm.value.pageSize = val
  searchForm.value.pageIndex = 1
  getPros()
}
const handleCurrentChange = (val) => {
  searchForm.value.pageIndex = val
  getPros()
}
const getToken = async () => {
  const res = await api.getTokenApi()
  store.commit('setToken', res.data.authorToken)
  getPros()
}
const changeCata = (type) => {
  searchForm.value.producttype = type
  searchForm.pageIndex = 1
  getPros()
}
onMounted(async () => {
  if (route.query.ExhCode) {
    store.commit('setExhCode', route.query.ExhCode)
  }
  if (route.query.ActorIdCode) {
    sessionStorage.setItem('ActorIdCode', route.query.ActorIdCode)
  }
  getToken()
})
</script>
<style lang="less">
.indexPage {
  background: rgb(245, 245, 245);
  .ltsBox {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 10px 0;
    ul {
      margin: 0;
      display: flex;
      align-items: flex-start;
      list-style: none;
      width: 100%;
      justify-content: space-between;
      li {
        width: 12%;
        padding: 0;
        margin: 0;
        cursor: pointer;
        border-radius: 8px;
        // padding-bottom: 15px;
        border-top-left-radius: 25px;
        border-top-right-radius: 25px;
        // height: 75px;
        img {
          width: 100%;
        }
      }
      li.active {
        background: #fff;
        box-shadow: 0px 2px 4px 0px rgb(188 188 188);
      }
    }
  }
  .searchBox {
    background: #fff;
    box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.2);
    padding: 10px;
    display: flex;
    align-content: center;
    .van-field {
      border: 1px solid #dcdfe6;
    }
    .van-cell {
      padding: 0px 6px;
      .van-cell__value {
        display: flex;
        align-items: center;
      }
    }
  }
  .listBox {
    padding: 2vw 5vw 0;
    img {
      width: 20vw;
      margin-right: 2vw;
    }
    .listItem {
      width: 100%;
      background: #fff;
      margin-bottom: 10px;
      display: flex;
      padding: 10px;
      box-sizing: border-box;
      border-radius: 4px;
      box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.2);
      align-items: center;
      cursor: pointer;
      .itemContent {
        text-align: left;
      }
      .companyName {
        font-size: 16px;
        font-weight: bold;
        padding-bottom: 10px;
      }
      .compantInfor {
        display: flex;
        align-items: center;
        span {
          font-size: 12px;
        }
      }
    }
  }
  .pageBox {
    margin: 10px auto;
    padding: 10px;
    background: #fff;
  }
}
@media screen and (min-width: 768px) {
  .indexPage {
    .ltsBox {
      ul {
        li {
          // height: 200px;
        }
      }
    }
    .listBox {
      padding: 2vw 0;
      display: flex;
      flex-wrap: wrap;
      .listItem {
        width: 32%;
        padding: 24px;
        img {
          width: 20%;
        }
        .companyName {
          font-size: 18px;
        }
        .compantInfor {
          span {
            font-size: 14px;
          }
        }
      }
      .listItem:nth-child(3n + 1),
      .listItem:nth-child(3n + 2) {
        margin-right: 2%;
      }
    }
    .pageBox {
      width: 100%;
    }
  }
}
</style>
